import React, { useEffect } from 'react';
import { useProgramOfStudies } from 'src/app/hooks/useProgramOfStudies';
import { useNavigate } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { ListQuestions } from './ListQuestions';
import { ContentQuestion } from './ContentQuestion';

export const UpdatePublicQuestions = () => {
  const navigate = useNavigate();
  const { selectedTaxonomy } = useProgramOfStudies();

  useEffect(() => {
    if (!selectedTaxonomy) {
      navigate('/ementa/banco-de-questoes');
    }
  }, []);

  if (!selectedTaxonomy) {
    return null;
  }

  return (
    <div className="main-screen">
      <Sidebar />

      <div className="main-content u-p-0">
        <div className="new-questions">
          <ListQuestions />

          <ContentQuestion />
        </div>
      </div>
    </div>
  );
};
